import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import useGetActiveConfieEmployeeCount from "../../CarrierAgreementMgmt/Employees/Confie/hooks/useGetActiveConfieEmpCount";
import useGetOnLeaveConfieEmployeeCount from "../../CarrierAgreementMgmt/Employees/Confie/hooks/useGetOnLeaveConfieEmpCount";
import useGetActiveFranchiseEmployeeCount from "../../CarrierAgreementMgmt/Employees/Confie/hooks/useGetActiveFranchiseEmployeeCount";
import useGetOnLeaveFranchiseEmployeeCount from "../../CarrierAgreementMgmt/Employees/Confie/hooks/useGetOnLeaveFranchiseEmployeeCount";
import useGetNewHireFranchiseEmployeeCount from "../../CarrierAgreementMgmt/Employees/Confie/hooks/useGetNewHireFranchiseEmployeeCount";
import useGetRehireFranchiseEmployeeCount from "../../CarrierAgreementMgmt/Employees/Confie/hooks/useGetRehireFranchiseEmployeeCount";
import useGetRehireConfieEmployeeCount from "../../CarrierAgreementMgmt/Employees/Confie/hooks/useGetRehireConfieEmployeeCount";
import useGetNewHireConfieEmployeeCount from "../../CarrierAgreementMgmt/Employees/Confie/hooks/useGetNewHireConfieEmployeeCount";
import { accountAtom } from "../../Login/atoms/AccountAtom";
import { useRecoilValue } from "recoil";
import useGetTressEmployeesCount from "modules/CarrierAgreementMgmt/Employees/Confie/hooks/useGetTressEmployeesCount";
import { permissionsSelector } from "modules/Login/selectors/permissionSelector";
import { PERMISSIONS } from "modules/PermissionsConstants";
// ChartJS.register(BarElement, Tooltip, Title, Legend);
const EmployeeChart = () => {
  //Permission
  const userPermissions = useRecoilValue(permissionsSelector);
  const usViewPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_employee_view;
  const mexicoViewPermission =
    PERMISSIONS.permission_employee_mexicoemployee_view;

  //employees
  const { data: activeConfieEmp } = useGetActiveConfieEmployeeCount();
  const { data: onLeaveConfieEmp } = useGetOnLeaveConfieEmployeeCount();
  const { data: newHireConfieEmp } = useGetNewHireConfieEmployeeCount();
  const { data: rehireConfieEmp } = useGetRehireConfieEmployeeCount();
  const { data: activeFranchiseEmp } = useGetActiveFranchiseEmployeeCount();
  const { data: onLeaveFranchiseEmp } = useGetOnLeaveFranchiseEmployeeCount();
  const { data: newHireFranchiseEmp } = useGetNewHireFranchiseEmployeeCount();
  const { data: rehireFranchiseEmp } = useGetRehireFranchiseEmployeeCount();

  //tress employees
  const { data: tressEmployeesCount } = useGetTressEmployeesCount();

  const user = useRecoilValue(accountAtom);
  const superUser = user?.isFranchise && user?.isNonFranchise;
  const franchise = user?.isFranchise && !user?.isNonFranchise;
  const confie = !user?.isFranchise && user?.isNonFranchise;

  const totalOfSixMonthsConfie =
    onLeaveConfieEmp + newHireConfieEmp + rehireConfieEmp;
  const totalOfConfie = totalOfSixMonthsConfie + activeConfieEmp;

  const totalOfSixMonthsFranchise =
    onLeaveFranchiseEmp + newHireFranchiseEmp + rehireFranchiseEmp;
  const totalOfActive = activeConfieEmp + activeFranchiseEmp;
  const totalOfFranchise = totalOfSixMonthsFranchise + activeFranchiseEmp;

  const totalOf =
    totalOfSixMonthsConfie +
    totalOfSixMonthsFranchise +
    totalOfActive +
    tressEmployeesCount?.totalCount;

  const superuserColumns = [
    {
      Name: "Active",
      ...(user?.isNonFranchise && { Confie: activeConfieEmp }),
      ...(user?.isFranchise && { Franchise: activeFranchiseEmp }),
      Mexico: tressEmployeesCount?.activeTressEmployees,
    },

    {
      Name: "On Leave",
      ...(user?.isNonFranchise && { Confie: onLeaveConfieEmp }),
      ...(user?.isFranchise && { Franchise: onLeaveFranchiseEmp }),
      Mexico: tressEmployeesCount?.onLeaveTressEmployees,
    },

    {
      Name: "New Hire",
      ...(user?.isNonFranchise && { Confie: newHireConfieEmp }),
      ...(user?.isFranchise && { Franchise: newHireFranchiseEmp }),
      Mexico: tressEmployeesCount?.newHireTressEmployees,
    },

    {
      Name: "Rehire",
      ...(user?.isNonFranchise && { Confie: rehireConfieEmp }),
      ...(user?.isNonFranchise && { Franchise: rehireFranchiseEmp }),
      Mexico: tressEmployeesCount?.rehireTressEmployees,
    },
  ];

  type LegendItem = { label: string; color: string };
  const legendItems: LegendItem[] = [];

  if (user?.isNonFranchise) {
    legendItems.push({ label: "Confie", color: "bg-tabColorDarkBlue" });
  }

  if (user?.isFranchise) {
    legendItems.push({ label: "Franchise", color: "bg-hsecondary" });
  }

  // Mexico is always shown
  legendItems.push({ label: "Mexico", color: "bg-tertiary" });

  return (
    <>
      <div className="grid grid-cols-2 items-center">
        <div className="grid sm:grid-cols-1">
          <h1 className="text-sm text-tertiary font-semibold">
            Employee Status
          </h1>
        </div>
        <div className="grid sm:grid-cols-1">
          <h4 className="text-right text-xs text-tertiary font-base">
            Total of{" "}
            <span className="text-base font-semibold">
              {superUser
                ? totalOf || ""
                : franchise
                ? totalOfFranchise + tressEmployeesCount?.totalCount
                : confie
                ? totalOfConfie + tressEmployeesCount?.totalCount
                : tressEmployeesCount?.totalCount}
            </span>
          </h4>
        </div>
      </div>

      <div className="flex flex-auto justify-center pt-7">
        <ResponsiveContainer height={170}>
          <BarChart
            className="flex items-center"
            height={300}
            width={300}
            data={superuserColumns}
            barCategoryGap={12}
            barGap={4}
            margin={{
              top: 5,
              right: 25,
              left: -13,
              bottom: 5,
            }}
          >
            <XAxis dataKey="Name" fontSize={9} angle={-30} dy={10} />
            <YAxis
              type="number"
              domain={[0, 50]}
              allowDataOverflow={true}
              fontSize={10}
            />
            <Tooltip />
            <>
              {user?.isNonFranchise && (
                <Bar dataKey="Confie" fill="#0078D7" minPointSize={5} />
              )}
              {user?.isFranchise && (
                <Bar dataKey="Franchise" fill="#EC4899" minPointSize={10} />
              )}
              <Bar
                dataKey="Mexico"
                fill="#01579E"
                minPointSize={5}
                barSize={25}
              />
            </>
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="flex items-center gap-2 mt-10 justify-center flex-row">
        {legendItems.map((item) => (
          <div key={item.label} className="flex flex-row items-center">
            <div className={`h-2 w-2 rounded-md ${item.color} m-1`} />
            <div className="inline-block text-xs4 font-normal">
              {item.label}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default EmployeeChart;
